/**
 * Hosted NVIDIA / Guardian demo (static `sak/index.html`).
 * Deploy from the `sak` repo: `bash scripts/deploy-devnet-demo.sh`
 * (Cloudflare Pages project name: `sak-devnet-test` — underscores are not allowed in CF project names).
 *
 * If your dashboard shows a different hostname (e.g. `sak-devnet-test.xxxxx.pages.dev`), update this URL once.
 */
export const SAK_DEVNET_TEST_DEMO_URL = "https://sak-devnet-test.pages.dev/";
